import ListColumnModel from '@/modules/base/model/list-column-model'
import getStateInfo from '@/modules/project/helpers/getStateInfo'
import { projectStates } from '@/modules/base/util/constants'

const { DRAFT, STARTED, FINISHED, PAID } = projectStates

export default class ProjectListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)

    this.displayed = data.displayed

    switch (this.name) {
      case 'budget':
      case 'outstandingBudget':
      case 'amountPaid': {
        this.setCurrencyType()
        this.aggFunc = 'sum'
        break
      }

      case 'state': {
        this.cellRenderer = 'stateCellRenderer'
        this.filter = true
        this.setFilterParam({
          valueFormatter: (param) => {
            const { value } = param
            return getStateInfo(value)
          },
          values: [DRAFT, STARTED, FINISHED, PAID],
        })
        this.getQuickFilterText = (params) => {
          return params.data?.stateLabel || params.value
        }
        break
      }
      case 'orderNumber': {
        this.cellRenderer = 'orderNumberCellRenderer'
        this.sortable = false
        break
      }
      case 'startDate': {
        this.setDateType()
        break
      }
      case 'createdAt':
      case 'updatedAt':
      {
        this.setDateTimeType()
        break
      }
      default: { return }
    }
  }
}
